import React, {useEffect, useState} from "react";
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    LineChart,
    Line,
    ReferenceLine,
    Label,
    ResponsiveContainer,
} from 'recharts';
import Skeleton from '@mui/material/Skeleton';
import {Areas} from "../../pages/Details";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';


interface LineChart {
    data : any,
    chips ?  : string,
    skeleton : boolean,
    startDate:string,
    endDate:string,
    areas :Areas[]
}

var xAxis1 = "date"


const getIntroOfPage = (epoch : number) => {
    let new_Date = new Date(epoch)
    return new_Date.toLocaleTimeString("en-us",{
        hour:"2-digit",minute:"2-digit"
    })
};


const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
        return (
            <div style={{
                backgroundColor:"white",
                padding:'0px 10px',
                border:'1px solid grey'
            }}>
                <p>{getIntroOfPage(label)}</p>
                {
                    payload.map((p:any,index:number)=>(
                        <p style={{color:p.color}} key={index}>{`${p.dataKey} : ${p.value}`}</p>
                    ))
                }
            </div>
        );
    }

    return null;
};


export const LineChartComponent = ({data,chips,skeleton,endDate,startDate,areas} : LineChart) =>{

    const [minMax,setMinMax] = useState({min:0,max:0})

    const [currentLine,setCurrentLine] = useState(areas[0])

    const convertToShortTime = (epoch:number) =>{
        let new_Date = new Date(epoch)
        return new_Date.toLocaleTimeString("en-us",{
            hour:"2-digit",minute:"2-digit"
        })
    }

    const getCurrentLine = (obj:any) =>{
        setCurrentLine({color:obj.name,property:obj.value})
    }


    useEffect(()=>{
        if(!chips){

        let item = currentLine.property

            const highest = data.reduce((previous:any, current:any) => {
                return current[item] > previous[item] ? current : previous;
            });
            const lowest = data.reduce((previous:any, current:any) => {
                return current[item] < previous[item] ? current : previous;
            });

            let min = lowest[item]===0 ? lowest[item] : lowest[item]-5

            setMinMax({max: Math.round(highest[item]+5),min: Math.round(min)})
        }
    },[data,currentLine])

    return(
            <>
                {
                    areas.length>1?
                        <FormControl>
                            {/*<FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel>*/}
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                defaultValue={currentLine.property}
                                onChange={(e)=>getCurrentLine(e.target)}
                            >
                                {
                                    areas.map(a=>(
                                        <FormControlLabel
                                            key={a.property}
                                            value={a.property}
                                            name={a.color}
                                            control={<Radio />}
                                            label={a.property} />
                                    ))
                                }
                            </RadioGroup>
                        </FormControl>
                        :''
                }


                        <ResponsiveContainer width="100%" height={200}>

                            {
                                skeleton ?
                                    <Skeleton animation="wave"
                                              style={{marginTop:"37px"}}
                                              height={500}
                                    />
                                    :
                                    <LineChart
                                        style={{marginTop:"37px"}}
                                        width={500}
                                        height={200}
                                        data={data}
                                        // onMouseUp={(e)=>{console.log('-----',e)}}
                                        syncId="anyId"
                                        margin={{
                                            top: 10,
                                            right: 30,
                                            left: 0,
                                            bottom: 0,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="1" horizontal={false} />
                                        {
                                            chips ?
                                                <XAxis
                                                    dataKey ={chips}
                                                    minTickGap={100}
                                                    dy={10}
                                                    axisLine={true}
                                                />
                                                :
                                                <XAxis
                                                    dataKey ={'epoch'}
                                                    minTickGap={100}
                                                    allowDataOverflow
                                                    tickFormatter={
                                                        (value: any, index: number) => convertToShortTime(value)
                                                    }
                                                    domain={[Date.parse(startDate), Date.parse(endDate)]}
                                                    type={"number"}
                                                    dy={10}
                                                    axisLine={true}
                                                />
                                        }git
                                        {
                                            chips?
                                                <YAxis axisLine={true}/>
                                                :
                                                <YAxis axisLine={true} domain={[minMax.min,minMax.max]}/>
                                        }


                                        {
                                            chips?
                                                <Tooltip/>
                                                :
                                            <Tooltip content={<CustomTooltip/>}/>
                                        }

                                        <Line
                                            type="monotone"
                                            dot={false}
                                            dataKey={currentLine.property}
                                            stroke={currentLine.color}
                                            strokeWidth={2.5}
                                            connectNulls
                                        />
                                    </LineChart>
                            }


                        </ResponsiveContainer>
            </>

    )
}